module.exports = __webpack_public_path__ + "assets/img/abd1ce583169608378b1938853d7dd89.png";